<template>
  <div>
    <div :class='[{ "is-active": isOpen }, "modal"]'>
      <div class='modal-background'></div>

      <div class='modal-card'>
        <header class='modal-card-head'>
          <h2 class='modal-card-title'>Add Blocked Recipient</h2>
          <button class='delete' aria-label='close' @click='onClose'></button>
        </header>

        <section class='modal-card-body'>
          <ErrorNotification
            v-if='errors.length'
            :messages='errors'
            @clear='$emit("clearErrors")'
          />

          <div class='field'>
            <label class='label'>Domain</label>
            <div class='control'>
              <input
                class='input'
                type='text'
                placeholder='Domain'
                ref='domainInput'
                v-model='domain'
                autocomplete='off'
              />
            </div>
          </div>

          <div class='field'>
            <label class='label'>Confirm Domain</label>
            <div class='control'>
              <input
                class='input'
                type='text'
                placeholder='Confirm Domain'
                v-model='confirmDomain'
                autocomplete='off'
              />
            </div>
          </div>

          <div class='field'>
            <label class='label'>Type of block</label>
            <div class='select'>
              <select v-model='blockType'>
                <option selected value='domainOnly'>Exactly this domain</option>
                <option value='subdomainOnly'>Only subdomains of this domain</option>
                <option value='domainAndSubdomains'>This domain and all subdomains</option>
              </select>
            </div>
          </div>

          <div class='field'>
            <label class='label'>Comment</label>
            <div class='control'>
              <textarea
                class='input'
                placeholder='Comment'
                v-model='comment'
                autocomplete='off'
              />
            </div>
          </div>
        </section>

        <footer class='modal-card-foot'>
          <div style='width: 100%'>
            <button
              class='button is-success'
              @click='onAddBlockedRecipient'
              :disabled='isSubmitDisabled'
            >
              Submit
            </button>
            <button
              class='button is-cancel'
              @click='onClose'
            >
              Cancel
            </button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorNotification from '@/components/ErrorNotification.vue';

export default {
  name: 'AddBlockedRecipient',

  components: {
    ErrorNotification
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      domain: '',
      confirmDomain: '',
      comment: '',
      blockType: 'domainOnly'
    }
  },

  mounted() {
    document.body.addEventListener('keydown', this.onKeydown);
    this.$nextTick(() => {
      this.$refs.domainInput.focus();
    });
  },

  unmounted() {
    document.body.removeEventListener('keydown', this.onKeydown);
  },

  computed: {
    isSubmitDisabled() {
      return !this.domain.length || this.domain !== this.confirmDomain || !this.comment.length;
    }
  },

  watch: {
    isOpen(val) {
      if (!val) {
        // reset values
        this.domain = '';
        this.confirmDomain = '';
        this.blockType = 'domainOnly';
        this.comment = '';
      }
    }
  },

  methods: {
    onKeydown(e) {
      if (!this.isOpen) return;

      if (e.which === 13 && !this.isSubmitDisabled) {
        this.onAddBlockedRecipient();
      }

      if (e.which === 27) {
        this.onClose();
      }
    },

    onAddBlockedRecipient() {
      if (this.domain !== this.confirmDomain) return;

      this.$emit('submit', {
        domain: this.domain,
        blockType: this.blockType,
        comment: this.comment
      });
    },

    onClose() {
      this.$emit('close');
    }
  }
}
</script>
